import React from 'react';
/**
 * Any time the `sessioncallogerror` classname is around text it will get logged
 * to session cam as an error event. This util is created as a helper to wrap errors/dead-ends
 * the user gets to in the flow.
 */
export var SessionCamTracking = function (_a) {
    var children = _a.children;
    return React.createElement("div", { className: "sessioncamlogerror" }, children);
};
